import { getAcumulado } from "../services/Rest.jsx";
import useFetch from "./useFetch";

const useAcumulado = (params) => {
  return useFetch(getAcumulado, true, params);
};

export default useAcumulado;
